import { ElementRef, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AppService } from '../app/app-api';
import { OrgAndStockroomService } from '../org-and-stockroom/org-and-stockroom-api';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { HttpService } from '../http/http-api';
import { SINCH_CHAT } from '@core/constants/api.constants';

declare var window: any;
declare var liveagent: any;

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  getBusinessStatus(): Observable<any> {
    return this.httpService.getAsObservable(SINCH_CHAT.GET_BUSINESS, {});
  }

  getagentStatus(): Observable<any> {
    return this.httpService.getAsObservable(SINCH_CHAT.GET_AGENT, {});
  }


}